function tickets() {

    var copytimeout = null;

    if (!!$('section.tickets-20').length) {

        $('section.tickets-20 .tab-nav a').on('click', function (event) {
            event.preventDefault();
            var el = $(this);
            var tabs = el.data('tabs');
            if (el.hasClass('active')) { return; }
            $('.tab').hide();
            $('.tab-nav').find('a.active').removeClass('active');
            el.addClass('active');
            var activeTab = el.attr('href');
            window.location.hash = activeTab;
            $(activeTab).fadeIn(300);
            //return false;
        });
    }

    var tickets_app = $('#tickets-app');

    if (tickets_app.length) {

        var ticket_app_settings = tickets_app.data('tickets-app');
        var eventcode = ticket_app_settings.event_code;
        var redirect = new URL(window.location);

        tickets_app
        .on('click', 'a.registered, a.closed', function (e) {
            e.preventDefault();
        })
        .on('click', 'a.available, a.available-same', function (e) {
            let $this = $(this);
            let ticket = $this.data('ticket');

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "select_item",
                ecommerce: {
                    currency: ticket.currency_code,
                    items: [{
                        item_id: ticket.id,
                        item_name: ticket.title,
                        price: ticket.price_value,
                        variant: ticket.sub_type,
                        // 'brand': productObj.brand,
                        // 'category': productObj.cat,
                        // 'position': productObj.position
                    }]
                },
                // 'eventCallback': function() {
                //     document.location = productObj.url
                // }
            });
            return true;
        })
        .on('click', 'a.register', function (e) {
            var _registerGuest = $('#registration-confirm');
            var el = $(this);
            var code = el.data('regcode');
            var types = el.data('regtypes');
            var title = ticket_app_settings.registration_title;

            redirect.searchParams.set('register', 'true');

            if (!!$('body.upp-pending').length) {
                _registerGuest.find('div.types-text').hide();
                _registerGuest.find('div.register-text').hide();
                _registerGuest.find('div.guest-text').hide();
                _registerGuest.find('div.pending-text').show();
                $('.btn-resend').on('click', function (e) {
                    e.preventDefault();
                    _registerGuest.fadeOut(300).promise().then(function () {
                        scrollToTop();
                        sendVerify(upp_page.verify, redirect.toString());
                    });
                });
            }
            else if (!!$('body.upp-guest').length) {
                //return true;
                $('#signup-form').data('redirect', redirect.toString());
                $('#login-form').data('redirect', redirect.toString());
                $('#lost-form').data('redirect', redirect.toString());
                _registerGuest.find('div.types-text').hide();
                _registerGuest.find('div.register-text').hide();
                _registerGuest.find('div.pending-text').hide();
                _registerGuest.find('div.guest-text').show();
            }
            else {
                _registerGuest.find('div.pending-text').hide();
                _registerGuest.find('div.guest-text').hide();
                _registerGuest.find('div.register-text').find('a.confirm').remove();
                _registerGuest.find('div.register-text').find('strong.regtitle').text(title);
                $('.regtype').remove();
                $('.typesback').remove();
                _registerGuest.find('div.types-text').hide();
                _registerGuest.find('div.register-text').find('.actions').append(`<a class="btn-main ${upp_assets.buttons.primary_btn} btn-lg confirm mb50" data-regcode="${code}">${_confirmreg} <span class="fas fa-chevron-right"></span></a>`);
                _registerGuest.find('div.register-text').show();
                $('.eventregname').html(title);
            }

            _registerGuest.fadeIn(300);
            e.preventDefault();
        })
        .on('run-register', 'a.register', function (event, code, type) {
            var el = $(this);
            var regdata = {
                source: document.location.hostname,
                type: ticket_app_settings.registration_type,
            };
            passport.register(code, regdata)
            .done(function (data, textStatus) {
                var regdate = moment(data.created_at).format('MMMM Do, YYYY');
                var regcode = data.regcode || '';
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Lead',
                    'leadEventId': data.event,
                    'leadEventInstance': data.instance,
                    'leadEventType': data.type,
                });
                el.attr('data-regdate', regdate).trigger('mark-success', [data, textStatus]);
            })
            .fail(function (jqXHR, textStatus, error) {
                el.trigger('mark-fail', [jqXHR, textStatus, error]);
            });
        })
        .on('mark-success', 'a.register', function (e) {
            var el = $(this);
            var title = el.data('regtitle');
            var regdate = el.data('regdate');
            if (!regdate) {
                regdate = 'Your Registration was Successful!';
            }
            else {
                regdate = `${_regdone2} ${regdate}`;
            }

            el
                .html(`${_regbtnhtml} <i class="fas fa-check"></i>`)
                .addClass('registered')
                .removeClass('register');

            el.parent().append(regHTML);
            el.parent().find('.price').append(`<span class="regnote" style="font-size:12px; display:none; color:#bbb;">${regdate}</span>`);
            el.parent().find('.price>span').fadeIn(300);
        })
        .on('mark-fail', 'a.register', function (e) {
            var el = $(this);
            el.html(_regerror)
                .addClass('error')
                .removeClass('working');
            setTimeout(function () {
                el.html(_regerror2);
                setTimeout(function () {
                    el.html(_registerbtn + ' <span class="fas fa-chevron-right"></span>')
                    .removeClass('error');
                }, 3000);
            }, 1500);
            log("Failed registering for " + el.data('regcode'));
        });

        $(document).on('click', '#registration-confirm a.confirm', function () {
            var _registerGuest = $('#registration-confirm');
            var code = ticket_app_settings.registration_code;
            var type = ticket_app_settings.registration_type;
            _registerGuest.fadeOut(300);
            tickets_app.find('a.register:first').trigger('run-register', [code, type]);
            tickets_app.find('a.register').trigger('mark-success');
            showResult(ticket_app_settings.registration_title + ' ' + _registersuccess, 'success');
        });

        tickets_app
        .on('click', 'a.waitlist, a.closed', function (e) {
            e.preventDefault();
        })
        .on('click', 'a.waitlist', function (e) {
            e.preventDefault();
            var $waitlistModal = $('#waitlist-confirm');
            var $this = $(this);
            var code = $this.data('regcode');
            var types = $this.data('regtypes');
            var title = ticket_app_settings.registration_title;

            redirect.searchParams.set('waitlist', 'true');

            if (!!$('body.upp-pending').length) {
                $waitlistModal.find('div.types-text').hide();
                $waitlistModal.find('div.register-text').hide();
                $waitlistModal.find('div.guest-text').hide();
                $waitlistModal.find('div.pending-text').show();
                $('.btn-resend').on('click', function (e) {
                    e.preventDefault();
                    $waitlistModal.fadeOut(300).promise().then(function () {
                        scrollToTop();
                        sendVerify(upp_page.verify, redirect.toString());
                    });
                });
                $waitlistModal.fadeIn(300);
            }
            else if (!!$('body.upp-guest').length) {
                //return true;
                $('#signup-form').data('redirect', redirect.toString());
                $('#login-form').data('redirect', redirect.toString());
                $('#lost-form').data('redirect', redirect.toString());
                $waitlistModal.find('div.types-text').hide();
                $waitlistModal.find('div.register-text').hide();
                $waitlistModal.find('div.pending-text').hide();
                $waitlistModal.find('div.guest-text').show();
                $waitlistModal.fadeIn(300);
            }
            else {
                $this.trigger('run-waitlist', ticket_app_settings.registration_code, ticket_app_settings.registration_type);
            }
        })
        .on('run-waitlist', 'a.waitlist', function (event, code, type) {
            var $this = $(this);
            var regdata = {
                source: document.location.hostname,
                type: ticket_app_settings.registration_type,
            };
            passport.register(code, regdata)
                .done(function (data, textStatus) {
                    var regdate = moment(data.created_at).format('MMMM Do, YYYY');
                    var regcode = data.regcode || '';
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'Lead',
                        'leadEventId': data.event,
                        'leadEventInstance': data.instance,
                        'leadEventType': data.type,
                    });
                    $this.attr('data-regdate', regdate).trigger('mark-success', [data, textStatus]);
                    showResult(`${ticket_app_settings.registration_title} ${_waitlistsuccess}`, 'success');
                })
                .fail(function (jqXHR, textStatus, error) {
                    $this.trigger('mark-fail', [jqXHR, textStatus, error]);
                });
        })
        .on('mark-success', 'a.waitlist', function (e) {
            var $this = $(this);
            var title = $this.data('regtitle');
            var regdate = $this.data('regdate');
            if (!regdate) {
                regdate = 'You joined the waitlist successfully!';
            }
            else {
                regdate = `${_waitlistdone} ${regdate}`;
            }

            return $this
                .html(`${_waitlistbtnjoined} <i class="fas fa-check"></i>`)
                .addClass('waitlisted')
                .removeClass('waitlist')
                .promise().then(function() {
                    $this.parent().append(regHTML);
                    $this.parent().find('.price').append(`<span class="regnote" style="font-size:12px; display:none; color:#bbb;">${regdate}</span>`);
                    $this.parent().find('.price>span').fadeIn(300);
                });
        })
        .on('mark-fail', 'a.waitlist', function (e) {
            var $this = $(this);
            return $this
                .html(_regerror)
                .addClass('error')
                .removeClass('working')
                .delay(1500)
                .html(_regerror2)
                .delay(3000)
                .html(`${_waitlistbtnjoin} <span class="fas fa-chevron-right"></span>`)
                .removeClass('error')
                .promise().then(function() {
                    log("Failed waitlisting for " + $this.data('regcode'));
                });
        });

        tickets_app
        .on('click', 'a.get-updates', function (e) {
            e.preventDefault();
            var el = $(this);
            var _updatesGuest = $('#updates-guest');
            if (!!$('body.upp-pending').length) {
                //showResult(_updatestextPending, 'warning');
                _updatesGuest.find('h1').html(_updatestextPending);
                _updatesGuest.find('p').html(_emailverifyupdates);
                _updatesGuest.find('div.guest-text .guest-text').hide();
                _updatesGuest.find('div.guest-text .pending-text').show();
                _updatesGuest.fadeIn(300);
                _updatesGuest.find('.btn-resend').on('click', function (e) {
                    e.preventDefault();
                    _updatesGuest.fadeOut(300).promise().then(function () {
                        scrollToTop();
                        sendVerify(upp_page.verify, redirect.toString());
                    });
                });
            }
            else if (!!$('body.upp-guest').length) {
                //showResult(_updatestext1, 'info');
                _updatesGuest.find('div.guest-text .guest-text').show();
                _updatesGuest.find('div.guest-text .pending-text').hide();
                _updatesGuest.find('h1').html(_updatestext1);
                _updatesGuest.find('p').html(_agreesignup2);
                _updatesGuest.fadeIn(300);

            }
            else {
                el.trigger('run-subscribe', eventcode);
            }
        })
        .on('run-subscribe', 'a.get-updates', function (event, code) {
            var el = $(this);
            el.addClass('working');

            passport.subscribe(eventcode)
            .done(function (data, textStatus) {
                log('done');
                tickets_app.find('a.get-updates').trigger('mark-success');
                showResult(`${_updatessubsrcibe} ${eventcode}`, 'success');
            })
            .fail(function (jqXHR, textStatus, error) {
                log('fail');
                el.trigger('mark-fail', [jqXHR, textStatus, error]);
            });
        })
        .on('mark-success', 'a.get-updates', function (e, code) {
            return $(this)
                .html(`${_subscribed} <i class="fas fa-check"></i>`)
                .addClass('subscribed')
                .removeClass('get-updates')
                .removeClass('working');
        })
        .on('mark-fail', 'a.get-updates', function (e, code) {
            return $(this)
                .html(_regerror)
                .addClass('error')
                .removeClass('working')
                .delay(1500)
                .html(_regerror2)
                .delay(3000)
                .html(_rbtnupdates)
                .removeClass('error')
                .promise().then(function () {
                    showResult(sprintf(__('Failed subscribing to %s', 'ultra-2015'), eventcode), 'error');
                });
        });

        tickets_app
        .on('click', 'span.regnote-wrap', function() {
            var $temp = $("<input>");
            $('.copied-success').remove();
            $("body").append($temp);
            $temp.val($(this).find('span.regcode').text()).select();
            document.execCommand("copy");
            $temp.remove();
            clearTimeout(copytimeout);
            $(this).prepend('<span class="copied-success" style="display:none;">✔ Copied to Clipboard</span>');
            $('.copied-success').fadeIn(200);

            copytimeout = setTimeout(function(){
                $('.copied-success').fadeOut(200);
                setTimeout(function(){
                    $('.copied-success').remove();
                }, 500);
            }, 3000);
        });

        $(document).on('logged-in', function (event, passport) {
            var subscription = passport.subscriptions.find(function (value) {
                return value.code == ticket_app_settings.event_code;
            });
            if (subscription !== undefined) {
                tickets_app.find('a.get-updates').trigger('mark-success');
            }

            var registration = passport.registrations.find(function (value) {
                return ticket_app_settings.registration_code == `${value.event}-${value.instance}`;
            });
            if (registration !== undefined) {
                // Registered
                var regdate = moment(registration.created_at).format('MMMM Do, YYYY');
                tickets_app.find('a.loginbtn')
                    .removeClass('loginbtn')
                    .addClass('register');
                tickets_app.find('a.register')
                    .attr('data-regdate', regdate)
                    .trigger('mark-success');
                tickets_app.find('a.waitlist')
                    .attr('data-regdate', regdate)
                    .trigger('mark-success');
            }
            else {
                // Not Registered
                getEventJSON().done(function(data) {
                    var event = data.find(function (value) {
                        return value.passport.registration_code == ticket_app_settings.registration_code;
                    });
                    if (event !== undefined && event.passport.register_status != 'Registration Available') {
                        // Registration Closed
                        tickets_app.find('a.register, a.loginbtn, a.waitlist')
                            .removeClass('register')
                            .removeClass('loginbtn')
                            .addClass('closed')
                            .html(_rbtnclosed);
                    }
                    else {
                        // Registration Open
                        tickets_app.find('a.loginbtn')
                            .removeClass('loginbtn')
                            .addClass('register')
                            .html(`${_registerbtn} <span class="fas fa-chevron-right"></span>`);

                        var auto_register = getUrlParam('register');
                        if (auto_register) {
                          tickets_app.find('a.register').first().trigger('click');
                        }

                        // Waitlist Open
                        tickets_app.find('a.loginbtn')
                            .removeClass('loginbtn')
                            .addClass('waitlist')
                            .html(`${_waitlistbtnjoin} <span class="fas fa-chevron-right"></span>`);

                        var auto_waitlist = getUrlParam('waitlist');
                        if (auto_waitlist) {
                            tickets_app.find('a.waitlist').first().trigger('click');
                        }
                    }
                });
            }
        });

        $(document).on('logged-out', function (event, passport) {
            tickets_app.find('a.subscribed')
                .removeClass('subscribed')
                .removeClass('working')
                .addClass('get-updates')
                .html(_rbtnupdates);

            tickets_app.find('a.registered')
                .removeClass('registered')
                .addClass('register')
                .html(__('Register', 'ultra-2015'));

            tickets_app.find('a.register, a.closed').each(function() {
                var $this = $(this);

                getEventJSON().done(function(data) {
                    var event = data.find(function (value) {
                        return value.passport.registration_code == ticket_app_settings.registration_code;
                    });
                    if (event !== undefined && event.passport.register_status != 'Registration Available') {
                        $this
                            .removeClass('register')
                            .removeClass('closed')
                            .addClass('loginbtn')
                            .html(`${_signin} <span class="fas fa-lock"></span>`);
                    }
                });
            });
        });

        tickets_app.each(function () {

            $('div.sold', this).append('<div class="sold-overlay"></div>');

            // Tickets Button
            $('.ticket-header a', this)
                .on('mouseenter', function () {
                    $(this).parent().parent().find('a.button').addClass('over');
                })
                .on('mouseleave', function () {
                    $(this).parent().parent().find('a.button').removeClass('over');
                });

            if (ticket_app_settings.enable_dynamic_ticket_status) {
                var ticket_firebase_app = firebase.initializeApp(ticket_app_settings.firebase_config);

                var ticket_database = `${ticket_app_settings.event_code}/${ticket_app_settings.slug}/`;

                var ticket_function = function (snapshot) {
                    let result = snapshot.val();

                    if (result) {
                        let registration = this.registration;
                        let registration_code = _.get(registration, 'regcode');
                        let ticket_message = $.validator.format(result.ticket_message, registration_code);

                        $('#tickets > .content').html(ticket_message);

                        if (result.release_timestamp && result.countdown_format) {
                            $('#tixcounter').countdown(result.release_timestamp)
                            .on('update.countdown', function (event) {
                                $(this).html(event.strftime(result.countdown_format));
                            })
                            .on('finish.countdown', function (event) {
                                if (result.countdown_finished) {
                                    $(this).html(result.countdown_finished);
                                }
                            });
                        }

                        if (result.tickets) {
                            $.each(result.tickets, function (ticket_key, ticket) {
                                var ticketbox = $('[data-ticket="' + ticket_key + '"]');

                                if (ticketbox.length) {
                                    setTimeout(function () {
                                        ticketbox
                                            .removeClass()
                                            .addClass('ticket');

                                        var ticketbtn = ticketbox.find('.purchase > a');
                                        ticketbtn
                                            .removeClass()
                                            .addClass('tix')
                                            .addClass('working');

                                        setTimeout(function () {
                                            ticketbox.addClass(ticket.status);
                                            ticketbtn.removeAttr('href');
                                            ticketbtn.html(ticket.button_text);

                                            if (ticket.url !== undefined) {
                                                var ticket_link;
                                                if (registration !== undefined) {
                                                    ticket_link = $.validator.format(ticket.url, registration_code);
                                                }
                                                else {
                                                    ticket_link = ticket.url;
                                                }
                                                ticketbtn
                                                    .attr('href', ticket_link)
                                                    .attr('target', '_blank');
                                            }
                                            if (ticket.class !== undefined) {
                                                ticketbtn.addClass(ticket.class);
                                            }
                                            ticketbtn
                                                .addClass(ticket.status)
                                                .removeClass('working');
                                        }, 2000);

                                        let registration_notice = ticket.registration_notice;
                                        if (registration_notice) {
                                            ticketbox.find('.regnote').html($.validator.format(registration_notice, registration_code));
                                        }
                                    }, 2000);
                                }
                            });
                        }
                    }
                };

                window.ticket_data_ref = ticket_firebase_app.database().ref(ticket_database + "default");
                window.ticket_data_ref_callback = window.ticket_data_ref.on('value', ticket_function, function (errorObject) {
                    console.log("The read failed: " + errorObject.code);
                });

                $(document).on('logged-out', function () {
                    $('.regnote').html('');

                    window.ticket_data_ref.off('value', window.ticket_data_ref_callback);
                    window.ticket_data_ref = ticket_firebase_app.database().ref(ticket_database + "default");
                    window.ticket_data_ref_callback = window.ticket_data_ref.on('value', window.ticket_data_ref_callback
                        , function (errorObject) {
                            console.log("The read failed: " + errorObject.code);
                        });
                });

                $(document).on('logged-in', function (event, passport) {
                    let registration = _.find(passport.registrations, {"code": ticket_app_settings.registration_code});

                    let new_ticket_db;
                    if (registration !== undefined) {
                        if ((ticket_app_settings.ticket_mode === undefined || ticket_app_settings.ticket_mode == 'points_level')
                            && passport.points_level !== undefined) {
                            new_ticket_db = ticket_database + passport.points_level;
                        }
                        else if (ticket_app_settings.ticket_mode == 'type') {
                            if (registration.type !== undefined && registration.type !== null && registration.type) {
                                new_ticket_db = ticket_database + registration.type;
                            }
                            else {
                                new_ticket_db = ticket_database + "empty";
                            }
                        }
                        else {
                            new_ticket_db = ticket_database + "default";
                        }
                    }
                    else {
                        new_ticket_db = ticket_database + "unregistered";
                    }

                    window.ticket_data_ref.off('value', window.ticket_data_ref_callback);
                    window.ticket_data_ref = ticket_firebase_app.database().ref(new_ticket_db);
                    window.ticket_data_ref_callback = window.ticket_data_ref.on('value', window.ticket_data_ref_callback
                        , function (errorObject) {
                            console.log("The read failed: " + errorObject.code);
                        }, {'registration': registration});
                });
            }
        });
    }
}

function fillRegistered(passport) {
    $.each(passport.registrations, function(index,registration) {
        tickets_app.find(`a[data-regcode="${registration.code}"]`).each(function () {
            var $this = $(this);
            var regdate = moment(registration.created_at).format('MMMM Do, YYYY');

            $('.regnote').remove();

            $this
                .addClass('working')
                .delay(500)
                .addClass('green-btn')
                .removeClass('twolines')
                .html(`${_regbtnhtml} <i class="fas fa-check"></i>`)
                .delay(300)
                .removeClass('working')
                .addClass('registered')
                .promise().then(function() {
                    $this.parent().find('.price').append(`<span class="regnote" style="font-size:12px; display:none; color:#bbb;">${_regdone2} ${regdate}</span>`);
                    $this.parents('.ticket').removeClass('soon');
                    $this.parent().find('.price>span').fadeIn(300);
                });
        });
        tickets_app.find(`a.waitlist[data-regcode="${registration.code}"]`).each(function () {
            $(this).trigger('mark-success');
        });
    });
}
